import React from 'react'
import PropTypes from 'prop-types'
import {connect, useSelector} from 'react-redux'
import i18n from 'i18next'
import actions from 'redux-auto'
import NachweisEinreichenBenachrichtigung from './NotificationTypes/NachweisEinreichenBenachrichtigung'
import KapitelEinreichenBenachrichtigung from './NotificationTypes/KapitelEinreichenBenachrichtigung'
import AufgabeAbschliessenBenachrichtigung from './NotificationTypes/AufgabeAbschliessenBenachrichtigung'
import NachweisAblehnenBenachrichtigung from './NotificationTypes/NachweisAblehnenBenachrichtigung'
import NachweisFreigebenBenachrichtigung from './NotificationTypes/NachweisFreigebenBenachrichtigung'
import NachweisFreigebenBenachrichtigungTrainer from './NotificationTypes/NachweisFreigebenBenachrichtigungTrainer'
import AufgabeKommentierenBenachrichtigung from './NotificationTypes/AufgabeKommentierenBenachrichtigung'
import AufgabeErstellenBenachrichtigung from './NotificationTypes/AufgabeErstellenBenachrichtigung'
import VersetzungsplanAbteilungUpdateBenachrichtigung from './NotificationTypes/VersetzungsplanAbteilungUpdateBenachrichtigung'
import KapitelFreigebenBenachrichtigung from './NotificationTypes/KapitelFreigebenBenachrichtigung'
import KapitelFreigebenBenachrichtigungTrainer from './NotificationTypes/KapitelFreigebenBenachrichtigungTrainer'
import KapitelAblehnenBenachrichtigung from './NotificationTypes/KapitelAblehnenBenachrichtigung'
import AbteilungAbschliessenBenachrichtigung from './NotificationTypes/AbteilungAbschliessenBenachrichtigung'
import VersetzungsplanTerminErstellenBenachrichtigung from './NotificationTypes/VersetzungsplanTerminErstellenBenachrichtigung'
import VersetzungsplanSerienterminErstellenBenachrichtigung from './NotificationTypes/VersetzungsplanSerienterminErstellenBenachrichtigung'
import MissedAusbildungsnachweisBenachrichtigung from './NotificationTypes/MissedAusbildungsnachweisBenachrichtigung'
import UpcommingChangeInAbteilungBenachrichtigungAzubi from './NotificationTypes/UpcommingChangeInAbteilungBenachrichtigungAzubi'
import UpcommingChangeInAbteilungBenachrichtigungAusbilder from './NotificationTypes/UpcommingChangeInAbteilungBenachrichtigungAusbilder'
import ProbezeitEndetBenachrichtigung from './NotificationTypes/ProbezeitEndetBenachrichtigung'
import ErstesJahrEndetBenachrichtigung from './NotificationTypes/ErstesJahrEndetBenachrichtigung'
import ZweitesJahrEndetBenachrichtigung from './NotificationTypes/ZweitesJahrEndetBenachrichtigung'
import AusbildungEndetBenachrichtigung from './NotificationTypes/AusbildungEndetBenachrichtigung'
import MessageBenachrichtigung from './NotificationTypes/MessageBenachrichtigung'
import SystemMessageBenachrichtigung from './NotificationTypes/SystemMessageBenachrichtigung'
import NachweisKontrolleBenachrichtigung from './NotificationTypes/NachweisKontrolleBenachrichtigung'
import VersetzungsplanPublishBenachrichtigung from './NotificationTypes/VersetzungsplanPublishBenachrichtigung'
import {useNavigate} from 'react-router-dom'

const notificationComponents = [
  {
    benachrichtigungType: 'KapitelEinreichenBenachrichtigung',
    component: KapitelEinreichenBenachrichtigung,
  },
  {
    benachrichtigungType: 'NachweisEinreichenBenachrichtigung',
    component: NachweisEinreichenBenachrichtigung,
  },
  {
    benachrichtigungType: 'AufgabeAbschliessenBenachrichtigung',
    component: AufgabeAbschliessenBenachrichtigung,
  },
  {
    benachrichtigungType: 'NachweisAblehnenBenachrichtigung',
    component: NachweisAblehnenBenachrichtigung,
  },
  {
    benachrichtigungType: 'NachweisFreigebenBenachrichtigung',
    component: NachweisFreigebenBenachrichtigung,
  },
  {
    benachrichtigungType: 'NachweisFreigebenBenachrichtigungTrainer',
    component: NachweisFreigebenBenachrichtigungTrainer,
  },
  {
    benachrichtigungType: 'AufgabeKommentierenBenachrichtigung',
    component: AufgabeKommentierenBenachrichtigung,
  },
  {
    benachrichtigungType: 'AufgabeErstellenBenachrichtigung',
    component: AufgabeErstellenBenachrichtigung,
  },
  {
    benachrichtigungType: 'VersetzungsplanAbteilungUpdateBenachrichtigung',
    component: VersetzungsplanAbteilungUpdateBenachrichtigung,
  },
  {
    benachrichtigungType: 'KapitelFreigebenBenachrichtigung',
    component: KapitelFreigebenBenachrichtigung,
  },
  {
    benachrichtigungType: 'KapitelFreigebenBenachrichtigungTrainer',
    component: KapitelFreigebenBenachrichtigungTrainer,
  },
  {
    benachrichtigungType: 'KapitelAblehnenBenachrichtigung',
    component: KapitelAblehnenBenachrichtigung,
  },
  {
    benachrichtigungType: 'AbteilungAbschliessenBenachrichtigung',
    component: AbteilungAbschliessenBenachrichtigung,
  },
  {
    benachrichtigungType: 'VersetzungsplanTerminErstellenBenachrichtigung',
    component: VersetzungsplanTerminErstellenBenachrichtigung,
  },
  {
    benachrichtigungType: 'VersetzungsplanSerienterminErstellenBenachrichtigung',
    component: VersetzungsplanSerienterminErstellenBenachrichtigung,
  },
  {
    benachrichtigungType: 'MissedAusbildungsnachweisBenachrichtigung',
    component: MissedAusbildungsnachweisBenachrichtigung,
  },
  {
    benachrichtigungType: 'UpcommingChangeInAbteilungBenachrichtigungAzubi',
    component: UpcommingChangeInAbteilungBenachrichtigungAzubi,
  },
  {
    benachrichtigungType: 'UpcommingChangeInAbteilungBenachrichtigungAusbilder',
    component: UpcommingChangeInAbteilungBenachrichtigungAusbilder,
  },
  {
    benachrichtigungType: 'ProbezeitEndetBenachrichtigung',
    component: ProbezeitEndetBenachrichtigung,
  },
  {
    benachrichtigungType: 'ErstesJahrEndetBenachrichtigung',
    component: ErstesJahrEndetBenachrichtigung,
  },
  {
    benachrichtigungType: 'ZweitesJahrEndetBenachrichtigung',
    component: ZweitesJahrEndetBenachrichtigung,
  },
  {
    benachrichtigungType: 'AusbildungEndetBenachrichtigung',
    component: AusbildungEndetBenachrichtigung,
  },
  {
    benachrichtigungType: 'MessageBenachrichtigung',
    component: MessageBenachrichtigung,
  },
  {
    benachrichtigungType: 'VersetzungsplanPublishBenachrichtigung',
    component: VersetzungsplanPublishBenachrichtigung,
  },
  {
    benachrichtigungType: 'NachweisKontrolleBenachrichtigung',
    component: NachweisKontrolleBenachrichtigung,
  },
  {
    benachrichtigungType: 'SystemMessageBenachrichtigung',
    component: SystemMessageBenachrichtigung,
  },
]

export const NotificationTypeSelector = props => {
  const {id, markAsUnread, hasBeenRead, markAsRead} = props
  const navigate = useNavigate()
  const currentUserId = useSelector(state => state.authentication.id)

  const handleClickNotification = location => {
    actions.benachrichtigungen.setFlyoutVisibility({value: false})
    if (location) {
      navigate(location)
    }
    if (!hasBeenRead) markAsRead({notificationId: id})
  }

  const findCorrectComponentByBenachrichtigungType = () => {
    const {benachrichtigungType} = props
    return notificationComponents.find(nc => nc.benachrichtigungType === benachrichtigungType).component
  }

  const Component = findCorrectComponentByBenachrichtigungType()

  return (
    <div className="notificationTypeSelector" id={id}>
      {!hasBeenRead && <div className="notificationList__unreadIndicator" />}

      {hasBeenRead && (
        <button
          type="button"
          className="notificationList__markAsUnreadIndicator"
          onClick={() => markAsUnread({notificationId: id})}>
          <div className="toolTip">
            <span className="darkerText">{i18n.t('notification_mark_as_unread')}</span>
          </div>
        </button>
      )}

      <Component
        {...props}
        currentUserId={currentUserId}
        onNotificationClick={location => handleClickNotification(location)}
      />
    </div>
  )
}

NotificationTypeSelector.propTypes = {
  benachrichtigungType: PropTypes.string.isRequired,
  senderId: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  hasBeenRead: PropTypes.bool.isRequired,
  markAsRead: PropTypes.func.isRequired,
  markAsUnread: PropTypes.func,
}

export default NotificationTypeSelector
